import request from '@/utils/request'

export function loginByUsername (username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function logout () {
  return Promise.resolve()
}

export function dingTalkLogin (data) {
  return request({
    url: `/cms/dingtalk/login`,
    method: 'post',
    data
  })
}
export function getDingTalkAppId (params) {
  return request({
    url: `/cms/dingtalk/get/appid`,
    method: 'get',
    params
  })
}

export function hasUser (params) {
  return request({
    url: '/reg/exist',
    method: 'get',
    params
  })
}
export function sendVerifyCode (params) {
  return request({
    url: '/user/phone/verifycode',
    method: 'get',
    params
  })
}
export function checkVerifyCode (code, params) {
  return request({
    url: `/reg/active/${code}`,
    method: 'get',
    params,
    noErrorShow: true
  })
}
export function resetPassword (data) {
  return request({
    url: `/user/forgetpassword/reset`,
    method: 'post',
    data
  })
}
export function register (data) {
  return request({
    url: `/reg`,
    method: 'post',
    data
  })
}
export function resendActiveEmail (data) {
  return request({
    url: `/reg/active`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js